import styled from '@emotion/styled';
import { faHistory } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Button from '~/common/components/Button';
import { useAuditHistoryWindow } from '~/common/hooks/useAuditHistoryWindow';
import type { AuditHistoryPageEnum } from '~/pages/AuditHistory/constants';

export const StyledAuditHistoryButton = styled(Button)<{
  customstyles?: string;
}>`
  color: ${(props) => props.theme.colors?.blue[600]};
  background: ${(props) => props.theme.colors?.gray[50]};
  border: ${(props) => `1px solid ${props.theme.colors?.blue[600]}`};

  // override styles
  padding-left: unset;
  padding-right: unset;
  & span {
    margin-inline-start: unset;
  }
  ${(props) => props.customstyles}
`;

type AuditHistoryButtonProps = Readonly<
  {
    auditId:
      | string
      | (typeof AuditHistoryPageEnum)[keyof typeof AuditHistoryPageEnum];
  } & Omit<Partial<Parameters<typeof Button>[0]>, 'onClick'>
>;

export default function AuditHistoryButton({
  auditId,
  ...props
}: AuditHistoryButtonProps) {
  const { handleChangePageId } = useAuditHistoryWindow();

  return (
    <StyledAuditHistoryButton
      {...props}
      rightIcon={<FontAwesomeIcon icon={faHistory} />}
      isPrimary={false}
      onClick={() => handleChangePageId(auditId)}
    />
  );
}
